import {
  type AbilitySummary,
  type ActivityHeatmap,
  type CapacityForecast,
  type CrossProjectAllocation,
  type MyDashboard,
  type PortfolioHealth,
  type PortfolioRoadmap,
  type ProjectHealth,
  type TeamDailyActivity,
} from '@apm/contracts';
import { apiFetch } from '../../lib/http';

function search(params: Record<string, string | undefined>): string {
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) if (value) query.set(key, value);

  const text = query.toString();
  return text ? `?${text}` : '';
}

export const dashboardApi = {
  abilities: () => apiFetch<AbilitySummary>('/me/abilities'),

  mine: () => apiFetch<MyDashboard>('/me/dashboard'),

  roadmap: (range: { from: string; to: string; asOf?: string | undefined }) =>
    apiFetch<PortfolioRoadmap>(`/portfolio/roadmap${search(range)}`),

  health: (asOf?: string) => apiFetch<PortfolioHealth>(`/portfolio/health${search({ asOf })}`),

  capacity: () => apiFetch<CapacityForecast>('/portfolio/capacity'),

  allocation: () => apiFetch<CrossProjectAllocation>('/portfolio/allocation'),

  projectHealth: (projectId: string, asOf?: string) =>
    apiFetch<ProjectHealth>(`/projects/${projectId}/reports/health${search({ asOf })}`),

  activity: (projectId: string, asOf?: string) =>
    apiFetch<ActivityHeatmap>(`/projects/${projectId}/reports/activity${search({ asOf })}`),

  /** Hoạt động trong ngày của đội — APM-DAY-c. `date` vắng = hôm nay (múi giờ tổ chức). */
  teamDaily: (date?: string) => apiFetch<TeamDailyActivity>(`/team-daily${search({ date })}`),
};

export const dashboardKeys = {
  abilities: ['me', 'abilities'] as const,
  mine: ['me', 'dashboard'] as const,
  roadmap: (from: string, to: string, asOf: string) =>
    ['portfolio', 'roadmap', from, to, asOf] as const,
  health: (asOf: string) => ['portfolio', 'health', asOf] as const,
  capacity: ['portfolio', 'capacity'] as const,
  allocation: ['portfolio', 'allocation'] as const,
  activity: (projectId: string, asOf: string) =>
    ['portfolio', 'activity', projectId, asOf] as const,
  projectHealth: (projectId: string, asOf: string) =>
    ['portfolio', 'project-health', projectId, asOf] as const,
  teamDaily: (date: string) => ['team-daily', date] as const,
};
